<template>
   <van-row class="cardContainer" :class="{ historyMode: isShowHistory }">
        <van-col span="5" class="dayColumn">
            <div class="dayImage">
                <img src="@/assets/themeThree/CalenderBlue.png" alt="">
                <div class="dateText" v-if="props.time">{{ formatUnixTimestamp(props.time)?.split(' ')[0] }}</div>
                <div class="dayText" v-else>{{ props.day }}</div>
            </div>
        </van-col>
        <van-col span="13"
            style="padding:0 10px; display: flex; align-items: center; border-right: 3px dashed #80808070;">
            <van-col span="24">
                <van-row>
                    <van-col span="24" v-if="isShowHistory ? true : checkDate(formatUnixTimestamp(props.time)) == 0">
                        <van-row class="topData">
                            <van-col span="12" class="topCol" style="border-right: 3px solid #80808070;">
                                <div class="toptext">{{ $t('activity.available') }}</div>
                                <div class="toptext" style="color: #ffff;">{{ formatCurrency(availableAmount) }}</div>
                            </van-col>
                            <van-col span="12" class="topCol">
                                <div class="toptext">{{ $t('activity.givenAmount') }}</div>
                                <div class="toptext" style="color: #ffff;">{{ formatCurrency(givenAmount) }}</div>
                            </van-col>
                        </van-row>
                    </van-col>

                    <van-col span="24" style="padding-left: 5px;">
                        <span
                            v-bind:class="['middle-texts', props.activityStatus == 0 || props.activityStatus == 11 || props.activityStatus == 2 ? 'middle-pending' : '']">
                            <P>{{ $t(props.labelOne!) }}: <span style="color: #27D48B;">{{ props.currenyLable ? 'R$' :
                                    '' }}
                                    {{ props.valueOne }}{{ props.currenyLable ? '' : '%' }}</span>
                            </P>
                            <P>{{ $t(props.labelTwo!) }}: <span style="color: #ffcb52;"> {{ props.valueTwo }}X</span>
                            </P>
                        </span>
                    </van-col>
                </van-row>
            </van-col>
        </van-col>
        <van-col span="6" style="padding-left: 10px; display: flex; align-items: center; justify-content: center; ">
            <div class="claimBtn"
                v-if="isShowHistory ? false : activityStatus == 0 && checkDate(formatUnixTimestamp(props.time)) == 0">
                <div class="click_btn" @click="clickOnButton">
                    {{ $t('activity.click') }}
                </div>
            </div>
            <span class="right-texts" v-else>
                <p v-if="props.activityStatus == 0 && returnTurnover" style="color: #ff0000;">{{
                    $t('activityStatus.noRewards')
                    }}</p>
                <p v-else-if="props.activityStatus == 0 || props.activityStatus == 11" style="color: #0484ff;">{{
                    $t('activityStatus.pending') }}</p>
                <p v-else-if="props.activityStatus == 1" style="color: #36d836;">{{ $t('activityStatus.completed') }}
                </p>
                <p v-else-if="props.activityStatus == 2" style="color: #ff0000;">{{ $t('activityStatus.noRewards') }}
                </p>
                <p v-else-if="props.activityStatus == 3" style="color: #ff0000;">{{ $t('activity.overdue')
                }}</p>
            </span>
        </van-col>

    </van-row>




</template>
<script lang="ts" setup>
import { } from 'vue';
import { checkDate, formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';

const props = defineProps({
    day: {
        type: Number
    },
    valueOne: {
        type: Number
    },
    valueTwo: {
        type: Number
    },
    currenyLable: {
        type: Boolean
    },
    labelOne: {
        type: String
    },
    labelTwo: {
        type: String
    },
    time: {
        type: Number,
        default: () => 0
    },
    activityStatus: {
        type: Number
    },
    returnTurnover: {
        type: Boolean,
        default: false
    },
    availableAmount: {
        type: Number,
        default: () => 0
    },
    givenAmount: {
        type: Number,
        default: () => 0
    },
    isShowHistory: {
        type: Boolean,
        default: false
    }
})
const emits = defineEmits(['getClaim'])
const clickOnButton = () => {
    emits('getClaim')
}
</script>
<style scoped>

.cardContainer {
    font-size: 13px;
    background: #110E52;
    border: 2px solid #0167ca; 
    border-radius: 20px;
    padding: 20px 0px;
    color: #ffffff;
    margin: 10px;
    box-shadow: 0px 0px 10px rgba(77, 98, 241, 0.4);
    
}

.dayColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-right: 3px dashed #80808070;
    align-items: center;
}

.dayImage img {
    width: 85%;
}

.dayImage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%
}


.dateText {
    position: absolute;
    top: 50%;
    padding: 5px 0;
    font-size: 6px;
    color: #3247CF;
    font-weight: 600;
}

.dayText {
    position: absolute;
    padding: 5px 0;
    top: 45%;
    font-size: 16px;
    color: #3247CF;
    font-weight: 600;
}

.topData {
    border-bottom: 1px solid #80808070;
    margin-bottom: 5px;
    padding: 10px 0;
}

.topCol {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
}

.toptext {
    padding: 5px 0 0;
    font-size: 11px;
}

.coins-img {
    position: absolute;
    right: 0rem;
    top: 35%;
    z-index: 800;
    width: 18%;
}

.div-card {
    width: 100%;
    padding: 0.5rem;
    padding-left: 0rem;
}

.middle-texts {}

.middle-pending {
    top: 2vh;
}

.middle-texts p {
    margin: 5px 0px !important;
    font-size: 78%;
}

.right-texts {}

.right-texts p {
    margin: 0px !important;
    font-size: 78%;
    top: 2.5vh;
}

/* Histroy Mode New Design */

.historyMode {
  background: #101423;
  border-radius: 10px;
  padding: 5px 10px;
  margin: 10px 0;
  border: none !important;
  box-shadow: 0 4px 12px rgba(0,0,0,0.4);
  display: flex;
  color:#6d788d;
}

.historyMode .dayImage img {
  width: 85%;
}

.historyMode .dateText {
    position: absolute;
    top: 50%; 
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 3vw; 
    white-space: nowrap;
    color: #3247CF;
    font-weight: 600;
    padding: 0;
    margin: 0;
    width: 100%;
    text-align: center;
}

.historyMode .middle-texts {
  color: #6d788d;
}

@media (min-width:450px) {

    .middle-texts {
        left: 22%;
    }

    .right-texts {
        left: 62%;
    }

    .coins-img {
        width: 25%;
        top: 1rem;
    }

    .div-card {
        height: none;
    }

    .middle-texts p {
        font-size: 100%;
    }

    .right-texts p {
        font-size: 100%;
    }

    .dateText {
        font-size: 11px;
    }
}

.click_btn {
    color: #cc3300;
    font-size: 11.5px;
    background: linear-gradient(90deg, #e9c986 0%, #d8bf83 50%, #d8a841 100%);
    border-radius: 5px;
    padding: 10px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 80%; 
    margin-top: 10px;
    box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.4);
    cursor: pointer;

}

.historyMode .dayImage {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
}

.historyMode .dayImage img {
    width: 85%;
    height: auto;
}

.historyMode .dateText {
    position: absolute;
    top: 60%; 
    left: 50%;
    transform: translate(-50%, -50%);
    color: #3247CF;
    font-weight: 600;
    white-space: nowrap;
    text-align: center;
    padding: 0 !important;
    margin: 0 !important;
    font-size: 8px;
}


@media (min-width: 350px) {
    .historyMode {
        padding: 10px 8px;
    }
    
    .historyMode .dateText {
        font-size: 9px;
    }

    .click_btn {
        width: 60%;;
    }
}

@media (min-width: 600px) {
    .historyMode .dayImage img {
        width: 100%;
    }

    .historyMode .dateText {
        font-size: 13px;
        top: 60%; 
    }
    
    .toptext {
        font-size: 13px;
    }
    
    .middle-texts p {
        font-size: 14px !important;
    }
}

@media (min-width: 1920px) {
    .historyMode .dateText {
        font-size: 16px;
    }
}
</style>